import React, { FC } from "react";
import { useTranslation } from "react-i18next";

const OverviewNotFoundPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page-content">
      <h1>{t("overviewNotFound.title")}</h1>
      <p>{t("overviewNotFound.text")}</p>
    </div>
  );
};

export default OverviewNotFoundPage;
